// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.spotlight.RentalManagerUserPropertySpotlightWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  BulkListingSpotlightRequestDto,
  CustomerListingSpotlightOptimizationConfigDto,
  GetSpotlightedListingsResponseDto,
  GetUserPropertySpotlightOverviewResponseDto,
  ListingSpotlightUpdateResultDto,
  SetOptimizationModeRequestDto,
  SetSmartConfigModeRequestDto,
} from '../..';

interface OverviewParams {
  bypassCache?: boolean;
}

export const RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Path =
  '/api/web/v1/users/properties/spotlight/excludeListings';

/**
 * Exclude listing spotlight for listings
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_excludeListings = (
  postData: BulkListingSpotlightRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, BulkListingSpotlightRequestDto, Array<ListingSpotlightUpdateResultDto>>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Path =
  '/api/web/v1/users/properties/spotlight/getOptimizationConfig';

/**
 * Get optimization config for spotlight
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig = (client = getClient()) => {
  return httpFrontEndRequest<never, never, CustomerListingSpotlightOptimizationConfigDto>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_list_Path = '/api/web/v1/users/properties/spotlight/list';

/**
 * Get listings with spotlight promotion
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_list = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetSpotlightedListingsResponseDto>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_overview_Path =
  '/api/web/v1/users/properties/spotlight/overview';

/**
 * Get spotlight overview for user properties
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_overview = (
  getParams: OverviewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OverviewParams, never, GetUserPropertySpotlightOverviewResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_overview_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Path =
  '/api/web/v1/users/properties/spotlight/pinListings';

/**
 * Pin listing spotlight for listings
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_pinListings = (
  postData: BulkListingSpotlightRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, BulkListingSpotlightRequestDto, Array<ListingSpotlightUpdateResultDto>>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Path =
  '/api/web/v1/users/properties/spotlight/setOptimizationMode';

/**
 * Set optimization mode for spotlight
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode = (
  postData: SetOptimizationModeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetOptimizationModeRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode_Path =
  '/api/web/v1/users/properties/spotlight/setSmartConfigMode';

/**
 * Set smart config mode for spotlight
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode = (
  postData: SetSmartConfigModeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetSmartConfigModeRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Path =
  '/api/web/v1/users/properties/spotlight/unexcludeListings';

/**
 * Unexclude listing spotlight for listings
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings = (
  postData: BulkListingSpotlightRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, BulkListingSpotlightRequestDto, Array<ListingSpotlightUpdateResultDto>>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Path =
  '/api/web/v1/users/properties/spotlight/unpinListings';

/**
 * Unpin listing spotlight for listings
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_unpinListings = (
  postData: BulkListingSpotlightRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, BulkListingSpotlightRequestDto, Array<ListingSpotlightUpdateResultDto>>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
